export default "__VITE_ASSET__BIseg4hl__"